/**
 * Typed access to build-time environment variables.
 *
 * All vars must be prefixed with `VITE_` to be exposed to the client bundle.
 * Missing required vars fail fast at boot rather than blowing up deep in a hook.
 */

type Env = {
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  INTELLIGENCE_BASE_URL: string;
  BRAIN_BASE_URL: string;
  MODE: string;
};

function readRequired(key: string): string {
  const value = import.meta.env[key];
  if (typeof value !== "string" || value.length === 0) {
    throw new Error(
      `Missing required env var ${key}. Check .env.local (dev) or Cloudflare Pages env (prod).`,
    );
  }
  return value;
}

export const env: Env = {
  SUPABASE_URL: readRequired("VITE_SUPABASE_URL"),
  SUPABASE_ANON_KEY: readRequired("VITE_SUPABASE_ANON_KEY"),
  INTELLIGENCE_BASE_URL: readRequired("VITE_INTELLIGENCE_BASE_URL"),
  BRAIN_BASE_URL: readRequired("VITE_BRAIN_BASE_URL"),
  MODE: import.meta.env.MODE,
};
